import { types, getRoot, flow, isAlive, getParent } from 'mobx-state-tree';
import { when } from 'mobx';
import Marketplace from '../../models/MarketPlace';
import Account from '../../models/Account';
import SellerAccountsSelection from './SellerAccountsSelection';

const AccountRef = types.reference(Account, {
  get(identifier, self) {
    const acc = getParent(self).markets.sellersAccounts.find(sa => sa.id === identifier);
    return acc && isAlive(acc) ? acc : null;
  },
  set(value) {
    return value.id;
  },
});

export const AccountsBarListings = types.compose(
  types
    .model('AccountsBar', {
      selectedSellerAccounts: types.optional(types.array(AccountRef), []),
      selectedDestinationMarketplace: types.optional(Marketplace, {}),
    })
    .views(self => ({
      get markets() {
        return getRoot(self).uiStore.settingsStore.markets;
      },
      get destinations() {
        return getRoot(self).uiStore.settingsStore.markets.destinations;
      },
      get defaultDestinationMarketplace() {
        // make a shallow copy of the default destinations from markets so we avoid having 2 of the same nodes
        return { ...getRoot(self).uiStore.settingsStore.markets.getDefaultDestination };
      },
      get defaultSellerAccount() {
        return getRoot(self).uiStore.settingsStore.markets.defaultSellersAccount;
      },
    }))
    .actions(self => ({
      afterCreate() {
        when(() => self.defaultDestinationMarketplace.id, () => self.init());
      },
      init() {
        self.setSelectedDestinationMarketplace(self.defaultDestinationMarketplace);
      },
      setSelectedDestinationMarketplace: flow(function* setSelectedDestinationMarketplace(
        destination,
      ) {
        self.selectedDestinationMarketplace = { ...destination };

        self.toggleSellectAllAccounts(self.selectedSellerAccounts.length); // unselect previous accounts
        try {
          yield self.markets.fetchSellersAccounts(destination.id);
          self.toggleSellectHeaderAccounts(); // select all current accounts
        } catch (e) {
          console.error('Selecting all accounts failed', e);
        }
      }),
    })),
  SellerAccountsSelection,
);

export default AccountsBarListings;
